import { render, staticRenderFns } from "./EmployeeAddEdit.vue?vue&type=template&id=b226915a&scoped=true"
import script from "./EmployeeAddEdit.vue?vue&type=script&lang=ts"
export * from "./EmployeeAddEdit.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeAddEdit.vue?vue&type=style&index=0&id=b226915a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b226915a",
  null
  
)

export default component.exports